import React, { useEffect, useState } from 'react'
import ModalContainer from '../../common/modal/ModalContainer'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { authUserInfo, validateFloatNumber } from '../../helpers/Util'

const PriceRangeModal = ({
    fieldName,
    setFilterOptions,
    onClickApply,
    onCloseModal
}) => {
    const [minRangeValue, setMinRangeValue] = useState('')
    const [maxRangeValue, setMaxRangeValue] = useState('')

    const onSetPriceRange = () => {
        let offerPriceList = []
        let offerPriceGroup = {
            brandId: authUserInfo()?.brandResponse?.id,
            minPrice: minRangeValue,
            maxPrice: maxRangeValue
        }
        offerPriceList.push(offerPriceGroup)
        setFilterOptions(() => ({
            [fieldName]: offerPriceList
        }))
    }

    useEffect(() => {
        onSetPriceRange()
    }, [minRangeValue, maxRangeValue])

    return (
        <ModalContainer
            className='price-range-modal'
            onCloseModal={() => onCloseModal}
        >
            {' '}
            <div className='common-popup'>
                <div className='common-popup-header d-flex justify-content-between'>
                    <div className='popup-tilte'>
                        <h3 className='semibold-16 mb-0'>Set Price Range</h3>
                    </div>
                    <div
                        className='close-btn cursor-pointer'
                        onClick={onCloseModal}
                    >
                        <CloseIcon />
                    </div>
                </div>

                <div className='common-popup-body p-4'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 sm:gap-5'>
                        <div className='form-group !mb-0'>
                            <label className='regular-14 gray_300 mb-2'>
                                Minimum Range ($)
                            </label>
                            <div className='flex items-center'>
                                <input
                                    type='text'
                                    name='minRange'
                                    placeholder='Min %'
                                    value={minRangeValue}
                                    onChange={(e) =>
                                        setMinRangeValue(e.target.value)
                                    }
                                    onKeyPress={validateFloatNumber}
                                    className='mb-3'
                                />
                            </div>
                        </div>
                        <div className='form-group'>
                            <label className='regular-14 gray_300 mb-2'>
                                Maximum Range ($)
                            </label>
                            <div className='flex items-center'>
                                <input
                                    type='text'
                                    name='maxRange'
                                    placeholder='Max %'
                                    value={maxRangeValue}
                                    onChange={(e) =>
                                        setMaxRangeValue(e.target.value)
                                    }
                                    onKeyPress={validateFloatNumber}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='common-popup-footer flex items-center justify-end'>
                    <button className='button gray mr-3' onClick={onCloseModal}>
                        <span className='text-xs'>Clear filter</span>
                    </button>
                    <button
                        className='button primary sm'
                        onClick={() => onClickApply()}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </ModalContainer>
    )
}

export default PriceRangeModal
